// extracted by mini-css-extract-plugin
export var actionButton = "_po-0";
export var actionMenuContainer = "_po-i";
export var bubble = "_po-2";
export var bubbleActionMenu = "_po-j";
export var bubbleContext = "_po-6";
export var bubbleItems = "_po-7";
export var customer = "_po-3";
export var divider = "_po-8";
export var fileList = "_po-9";
export var hiddenComment = "_po-o";
export var infoAbove = "_po-a";
export var internal = "_po-4";
export var lightActionButton = "_po-1";
export var link = "_po-b";
export var merchant = "_po-5";
export var message = "_po-c";
export var profilePicture = "_po-e";
export var quillToolbarContainer = "_po-f";
export var senderDate = "_po-g";
export var senderDateCustomer = "_po-h";
export var senderName = "_po-d";
export var time = "_po-k";
export var uploadedImage = "_po-l";
export var username = "_po-m";
export var xsmall = "_po-n";